import { TrueBase, css, html } from "../TrueBase/TrueBase";

/**
 * @customelement true-section
 * @description
 * A display component that wraps around a row of components. Used for seperation of sections.
 *
 */
export class TrueSection extends TrueBase {
  static get properties() {
    return {
      setOverlay: {
        type: Boolean,
      },
      fullWidth: {
        type: Boolean,
      },
      contentFullWidth: {
        type: Boolean,
      },
    };
  }

  constructor() {
    super();
    this.setOverlay = false;
    this.fullWidth = false;
    this.horizontalContentPosition = "center";
  }

  connectedCallback() {
    super.connectedCallback() && super.connectedCallback;
    const sectionEvent = new CustomEvent("true-section-loaded");
    this.dispatchEvent(sectionEvent);
  }

  render() {
    return html`
      <section class="tp-content-wrapper">
        <div class="section-background"></div>
        ${this.setOverlay ? html`<div class="overlay"></div>` : ""}
        <div class="section-content__wrapper">
          <slot></slot>
        </div>
        <slot name="imageSlot"></slot>
      </section>
    `;
  }

  static get styles() {
    return [
      super.styles,
      css`
        :host {
          display: block;
          margin: var(--section-margin, 2em 0);
          background: var(
            --section-background,
            var(--section-background-default, transparent)
          );
          height: var(--section-height, auto);
        }

        * {
          box-sizing: border-box;
          transition: 0.3s ease-in-out;
        }

        section {
          position: relative;
          display: var(--section-display, block);
          flex-direction: var(--section-flex-direction, column);
          padding: var(--section-padding, 2em);
          height: 100%;
          margin: 0 auto;
          max-width: var(--section-max-width, 1284px);
          border-radius: var(--section-border-radius, 0);
          border: var(--section-border, none);
          background: var(--section-content-wrap-background, transparent);
        }

        .section-background {
          position: absolute;
          top: 0;
          left: var(--section-background-left, 0);
          right: var(--section-background-right, 0);
          width: var(--section-background-width, 100%);
          height: var(--section-background-height, 100%);
          background: var(
            --section-content-background,
            var(--section-content-background-color-default, transparent)
          );
          z-index: var(--section-background-z-index, -1);
          border-radius: var(--section-border-radius, 0);
        }

        .section-content__wrapper {
          color: var(--section-text-color, inherit);
          padding-top: var(--section-content-padding-top, 0);
          padding-bottom: var(--section-content-padding-bottom, 0);
          padding-left: var(--section-content-padding-left, 0);
          padding-right: var(--section-content-padding-right, 0);
          max-width: var(--section-content-max-width, 100%);
          width: 100%;
          z-index: var(--section-content-z-index, 2);
          margin: var(--section-content-margin, 0);
          height: var(--section-content-height, auto);
        }

        ::slotted(true-image-responsive),
        ::slotted(true-image) {
          border-radius: var(--section-border-radius, 0);
        }

        ::slotted([slot="imageSlot"]) {
          position: absolute;
          top: 0;
          right: 0;
          left: 0;
          bottom: 0;
          z-index: var(--section-image-z-index, 0);
          border-radius: var(--section-border-radius, 0);
        }

        .overlay {
          position: absolute;
          top: 0;
          right: 0;
          left: 0;
          bottom: 0;
          background-color: var(
            --section-overlay-background,
            rgba(0, 0, 0, 0.5)
          );
          z-index: var(--section-overlay-z-index, 1);
          border-radius: var(--section-border-radius, 0);
        }

        :host([fullWidth]) section {
          max-width: none;
        }

        :host([contentFullWidth]) .section-content__wrapper {
          max-width: none;
        }
      `,
    ];
  }
}

window.customElements.get("true-section") ||
  window.customElements.define("true-section", TrueSection);
